import React, { useState, createContext } from 'react';

export const DarkModeContext = createContext();

const DarkModeProvider = ({ children }) => {

  const [darkMode, setDarkMode] = useState(false);

  return (
    <DarkModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export default DarkModeProvider;